<app-menu></app-menu>
<p>application works!</p>
